module.exports = __webpack_public_path__ + "assets/18e540d8f5232cb63715d0948dbe2166.png";